import React from "react";
import "@/App.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import VenturesSection from "./components/VenturesSection";
import CapabilitiesSection from "./components/CapabilitiesSection";
import TeamSection from "./components/TeamSection";
import LowerSections from "./components/LowerSections";

function App() {
  return (
    <div className="app-wrapper">
      <Navbar />
      <HeroSection />
      <VenturesSection />
      <CapabilitiesSection />
      <TeamSection />
      <LowerSections />
    </div>
  );
}

export default App;
